@import 'nprogress/nprogress.css';

#nprogress .bar {
  z-index: 1000;
}

#nprogress .spinner {
  top: auto;
  bottom: 15px;
  z-index: 1000;
}
